// extracted by mini-css-extract-plugin
export default {"container":"ReplaceThumbnailModal_container__HJU2V","restoreButton":"ReplaceThumbnailModal_restoreButton__fDE2N","title":"ReplaceThumbnailModal_title__P8hXW"};